import { scrubInheritedEvidenceBinding } from './varianceActionEvidenceSnapshot.js';

const firstNonBlank = (...values) => values.find((value) => (
  value !== undefined
  && value !== null
  && String(value).trim() !== ''
)) || '';

const normalizeCode = (value) => String(value || '').trim().toUpperCase();

export const cpqInheritanceOverrideKey = (contextOrRow = {}) => {
  const row = contextOrRow.row || contextOrRow;
  return firstNonBlank(
    contextOrRow.sourceRowKey,
    row.sourceRowKey,
    contextOrRow.rowKey,
    row.rowKey,
    contextOrRow.id,
    row.id,
    contextOrRow.storageKey,
    row.storageKey,
    contextOrRow.fileRowId,
    row.fileRowId,
    [
      contextOrRow.bac || row.bac,
      contextOrRow.rawProductCode || contextOrRow.originalCpqProductCode || row.rawProductCode || row.originalCpqProductCode || row.productCode || row.normalizedProductCode,
      contextOrRow.productCode || row.oemProductCode || row.normalizedProductCode,
      row.budget,
      row.serviceMonth || row.serviceMonthRaw,
    ].filter((part) => part !== undefined && part !== null && String(part).trim() !== '').join('|'),
  );
};

export const restoredCpqInheritanceRow = (row = {}) => {
  const originalProductCode = firstNonBlank(
    row.rawProductCode,
    row.originalCpqProductCode,
    row.productCode,
    row.normalizedProductCode,
  );
  const inheritedProductCode = firstNonBlank(
    row.inheritedProductCode,
    row.displayProductCode,
    row.oemProductCode,
  );
  if (!originalProductCode || !inheritedProductCode || normalizeCode(originalProductCode) === normalizeCode(inheritedProductCode)) {
    return row;
  }
  const restored = {
    ...row,
    productCode: originalProductCode,
    oemProductCode: originalProductCode,
    normalizedProductCode: originalProductCode,
    displayProductCode: originalProductCode,
    originalCpqProductCode: '',
    rawProductCode: '',
    inheritedProductCode: '',
    hasInheritedDisplayCode: false,
    inheritedEvidenceCleared: true,
  };
  scrubInheritedEvidenceBinding(restored);
  return restored;
};

export const applyCpqInheritanceOverrides = (rows = [], overrides = {}) => {
  if (!overrides || !Object.keys(overrides).length) return rows;
  return rows.map((row) => (overrides[cpqInheritanceOverrideKey(row)]
    ? restoredCpqInheritanceRow(row)
    : row));
};
